import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { FC } from "react";

interface DisputeAmountConfirmationPopupProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  totalDisputedAmounts: string;
  isSubmitting?: boolean;
}

export const DisputeAmountConfirmationPopup: FC<DisputeAmountConfirmationPopupProps> = ({
  open,
  onClose,
  onConfirm,
  totalDisputedAmounts,
  isSubmitting = false,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirm Changes</DialogTitle>
      <DialogContent>
        <Typography sx={{ paddingTop: "20px" }} variant="body1">
          The new total of remaining open balance is <b>{totalDisputedAmounts}</b>. Are you sure?
        </Typography>
      </DialogContent>
      <DialogActions sx={{ backgroundColor: "transparent" }}>
        <Button variant="outlined" onClick={onClose} disabled={isSubmitting}>
          Go back
        </Button>
        <Button variant="contained" color="primary" onClick={onConfirm} disabled={isSubmitting}>
          Confirm {isSubmitting && <CircularProgress size={14} style={{ marginLeft: "12px", color: "#101828" }} />}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
